const TEXTAREA_VALUE_TYPES = new Set(["LONG_TEXT"]);
const NUMERIC_VALUE_TYPES = new Set([
  "NUMBER",
  "INTEGER",
  "INTEGER_POSITIVE",
  "INTEGER_NEGATIVE",
  "INTEGER_ZERO_OR_POSITIVE",
  "PERCENTAGE",
  "AGE",
]);
const COORDINATE_VALUE_TYPES = new Set(["COORDINATE"]);
const COORDINATE_ATTRIBUTE_IDS = new Set(["cPGCeyMceZl"]);
const FILE_VALUE_TYPES = new Set(["FILE_RESOURCE", "IMAGE"]);
const FILE_ATTRIBUTE_IDS = new Set(["Ax9xIaMCs52"]);
const YEAR_ATTRIBUTE_IDS = new Set(["Ik7fouv4KOA", "pWkYqcKukAY"]);
export const TRACKER_GEOMETRY_FIELD_NAME = "__trackerGeometry";
const GEOMETRY_PROGRAM_IDS = new Set(["nGFVo65uUE4"]);
const YEAR_FIELD_MATCHER = /\byear\b/i;
const GENERATED_ATTRIBUTE_MATCHER = /\b(auto[-\s]?generated|automatically generated|fill(?:ed)? automatically)\b/i;
const UNIQUE_ID_MATCHER = /\bunique\s+(id|identifier)\b/i;
const AMSEC_LEGACY_FIELDS = [
  {
    match: "dcact amsec component",
    label: "AMSEC Component",
  },
  {
    match: "dcact amsec status of implementation",
    label: "AMSEC Status of Implementation",
  },
  {
    match: "dcact amsec relationships",
    label: "Relationships",
  },
  {
    match: "dcact amsec number of beneficiaries female",
    label: "Number of female beneficiaries",
  },
  {
    match: "dcact amsec number of beneficiaries male",
    label: "Number of male beneficiaries",
  },
  {
    match: "dcact amsec name of responsible institution or schedule officer",
    label: "Name of responsible institution or schedule officer",
  },
  {
    match: "dcact amsec application requirement for beneficiaries",
    label: "Application requirement beneficiaries",
  },
  {
    match: "dcact amsec ownership",
    label: "Ownership Type",
  },
  {
    match: "dcact amsec contact details of institution or schedule officer",
    label: "Contact details of institution or schedule officer",
  },
];
const LEGACY_LABEL_OVERRIDES_BY_NORMALIZED_LABEL = {
  sex: "Gender",
  "sub statutory committee department": "Statutory committee department",
  "dpat name of sub structure": "Name of Sub Structure",
  "dpat sub structure committee": "Sub Structure Committe Category",
  // "dpat sub commitee category": "sub commitee category",
};

const INPUT_TYPE_BY_VALUE_TYPE = {
  DATE: "date",
  DATETIME: "datetime-local",
  TIME: "time",
  EMAIL: "email",
  PHONE_NUMBER: "tel",
  URL: "url",
};
const REGISTRATION_LABEL_OVERRIDES = {
  zud2JY8pPTV: "Has this bill been distributed",
  LQLke1N578q: "Billing Type",
  k921oNWPSd4: "Activity Sector",
  DVNScIHo9ik: "Select Budget Category",
  Ik7fouv4KOA: "Select Year",
  qdDngSjZY9H: "Classification",
  xJWv6hywE6t: "Staff Department Unit",
  ZvZNxRhU4VP: "Number of females",
  XZTj0OIaCW3: "Number of males",
  B7jdqUI7GCR: "At least Three Ordinary Meetings Held (GA)",
  VG5LYobYDbk: "Two Weeks Notice Before Ordinary Meetings Held (GA)",
  iST35r1RAuK: "Evidence of GA Meetings Minutes",
};
const EVENT_SECTION_HEADER_LABELS = new Set([
  "aap progress report",
  "gender support program data",
  "nutrition oriented interventions",
  "tree planting report",
]);

export const PROGRAM_METADATA_FIELDS =
  "id,displayName,shortName,description,programType,featureType,organisationUnits[id,path],trackedEntityType[id,displayName,featureType,trackedEntityTypeAttributes[sortOrder,mandatory,trackedEntityAttribute[id,displayName,displayFormName,shortName,description,valueType,generated,pattern,unique,optionSet[id,displayName,options[id,displayName,code]]]]],programTrackedEntityAttributes[sortOrder,mandatory,allowFutureDate,renderOptionsAsRadio,displayInList,trackedEntityAttribute[id,displayName,displayFormName,shortName,description,valueType,generated,pattern,unique,optionSet[id,displayName,options[id,displayName,code]]]],programStages[id,displayName,repeatable,programStageDataElements[sortOrder,compulsory,allowFutureDate,dataElement[id,displayName,displayFormName,shortName,description,valueType,optionSet[id,displayName,options[id,displayName,code]]]]]";
export const PROGRAM_RULE_FIELDS =
  "id,displayName,condition,programRuleActions[id,programRuleActionType,content,data,option[id,displayName,code],optionGroup[id,displayName,code],trackedEntityAttribute[id,displayName,displayFormName],dataElement[id,displayName,displayFormName]]";
export const PROGRAM_RULE_VARIABLE_FIELDS =
  "id,displayName,name,useCodeForOptionSet,programRuleVariableSourceType,trackedEntityAttribute[id,displayName,displayFormName],dataElement[id,displayName,displayFormName]";

function buildOptionLabel(option) {
  return option?.displayName || option?.name || option?.code || option?.id || "Unnamed option";
}

function buildOptionValue(option) {
  return option?.code || option?.displayName || option?.name || option?.id || "";
}

function normalizeMetadataLabel(value) {
  return String(value || "")
    .toLowerCase()
    .replace(/&/g, " and ")
    .replace(/[^a-z0-9]+/g, " ")
    .trim()
    .replace(/\s+/g, " ");
}

function isOtherSpecifyField(field) {
  const normalizedLabel = normalizeMetadataLabel(field?.label);
  return (
    field?.type !== "select" &&
    /\bothers?\b/.test(normalizedLabel) &&
    normalizedLabel.includes("specif")
  );
}

function isOtherOption(option) {
  const normalizedLabel = normalizeMetadataLabel(option?.label);
  const normalizedValue = normalizeMetadataLabel(option?.value);
  return (
    normalizedLabel === "other" ||
    normalizedLabel === "others" ||
    (/^others?\b/.test(normalizedLabel) && normalizedLabel.includes("specif")) ||
    normalizedValue === "other" ||
    normalizedValue === "others"
  );
}

function addOtherSpecifyConditions(fields) {
  return (fields || []).map((field, index, allFields) => {
    if (!isOtherSpecifyField(field)) return field;

    let controllingField = null;
    for (let previousIndex = index - 1; previousIndex >= 0; previousIndex -= 1) {
      const candidate = allFields[previousIndex];
      if (candidate?.generated) continue;
      controllingField = candidate;
      break;
    }

    if (controllingField?.type !== "select") return field;

    const otherValues = (controllingField.options || [])
      .filter(isOtherOption)
      .map((option) => option.value);
    if (otherValues.length === 0) return field;

    return {
      ...field,
      required: true,
      visibleWhen: {
        fieldName: controllingField.name,
        values: otherValues,
      },
    };
  });
}

function parseSimpleRuleComparison(condition) {
  const normalizedCondition = String(condition || "").trim();
  const comparisonPattern = /A\{([^}]+)\}\s*(==|!=)\s*(["'])(.*?)\3/g;
  const comparisons = Array.from(normalizedCondition.matchAll(comparisonPattern));

  if (comparisons.length === 0) {
    return null;
  }

  const firstVariableName = normalizeMetadataLabel(comparisons[0][1]);
  const firstOperator = comparisons[0][2];
  const onlySimpleOrConditions =
    comparisons.length === 1 ||
    normalizedCondition
      .replace(comparisonPattern, "")
      .split("||")
      .every((part) => part.trim() === "");

  if (
    !onlySimpleOrConditions ||
    comparisons.some(
      (comparison) =>
        normalizeMetadataLabel(comparison[1]) !== firstVariableName ||
        comparison[2] !== firstOperator,
    )
  ) {
    return null;
  }

  return {
    variableName: comparisons[0][1],
    operator: firstOperator === "!=" ? "notEquals" : "equals",
    values: comparisons.map((comparison) => comparison[4]),
  };
}

function getProgramRuleVariableAttributeMap(programMetadata) {
  return (programMetadata?.programRuleVariables || []).reduce((acc, variable) => {
    const attributeId = variable?.trackedEntityAttribute?.id;
    const variableNames = [
      variable?.name,
      variable?.displayName,
      variable?.trackedEntityAttribute?.displayName,
      variable?.trackedEntityAttribute?.displayFormName,
    ];

    if (!attributeId) return acc;

    variableNames.forEach((variableName) => {
      const normalizedName = normalizeMetadataLabel(variableName);
      if (normalizedName) {
        acc.set(normalizedName, attributeId);
      }
    });

    return acc;
  }, new Map());
}

function getRuleActionTargetAttributeId(action) {
  return action?.trackedEntityAttribute?.id || "";
}

function getRuleActionOptionValue(action) {
  return action?.option?.code || action?.option?.displayName || action?.option?.name || action?.option?.id || "";
}

function buildFieldConditionFromRule(rule, variableAttributeMap) {
  const comparison = parseSimpleRuleComparison(rule?.condition);
  if (!comparison) return null;

  const controllerFieldName = variableAttributeMap.get(normalizeMetadataLabel(comparison.variableName));
  if (!controllerFieldName) return null;

  return {
    fieldName: controllerFieldName,
    values: comparison.values,
    operator: comparison.operator,
    source: "programRule",
    ruleId: rule?.id || "",
  };
}

function mergeFieldCondition(existingCondition, nextCondition) {
  if (!nextCondition) return existingCondition;
  if (!existingCondition?.fieldName) return nextCondition;

  if (
    existingCondition.fieldName === nextCondition.fieldName &&
    existingCondition.operator === nextCondition.operator
  ) {
    return {
      ...existingCondition,
      values: Array.from(new Set([...(existingCondition.values || []), ...(nextCondition.values || [])])),
    };
  }

  return existingCondition;
}

function expandConditionValuesFromControllerField(condition, fields) {
  if (!condition?.fieldName) return condition;

  const controllerField = (fields || []).find((field) => field?.name === condition.fieldName);
  const conditionValues = Array.isArray(condition.values) ? condition.values : [];
  const expandedValues = new Set(conditionValues);

  (controllerField?.options || []).forEach((option) => {
    const optionCandidates = [option?.label, option?.value];
    const matchesConditionValue = conditionValues.some((conditionValue) =>
      optionCandidates.some(
        (candidate) =>
          String(candidate) === String(conditionValue) ||
          normalizeMetadataLabel(candidate) === normalizeMetadataLabel(conditionValue),
      ),
    );

    if (matchesConditionValue && option?.value !== undefined && option?.value !== null) {
      expandedValues.add(option.value);
    }
  });

  return {
    ...condition,
    values: Array.from(expandedValues),
  };
}

function applyProgramRuleConditions(fields, programMetadata) {
  const rules = Array.isArray(programMetadata?.programRules) ? programMetadata.programRules : [];
  if (rules.length === 0) return fields;

  const variableAttributeMap = getProgramRuleVariableAttributeMap(programMetadata);
  if (variableAttributeMap.size === 0) return fields;

  const fieldByName = new Map((fields || []).map((field) => [field.name, field]));

  rules.forEach((rule) => {
    const condition = expandConditionValuesFromControllerField(
      buildFieldConditionFromRule(rule, variableAttributeMap),
      fields,
    );
    if (!condition) return;

    (rule?.programRuleActions || []).forEach((action) => {
      const targetAttributeId = getRuleActionTargetAttributeId(action);
      const field = fieldByName.get(targetAttributeId);
      const actionType = String(action?.programRuleActionType || "").toUpperCase();

      if (!field) return;

      if (actionType === "HIDEFIELD") {
        fieldByName.set(targetAttributeId, {
          ...field,
          hiddenWhen: mergeFieldCondition(field.hiddenWhen, condition),
        });
        return;
      }

      if (actionType === "SETMANDATORYFIELD") {
        fieldByName.set(targetAttributeId, {
          ...field,
          requiredWhen: mergeFieldCondition(field.requiredWhen, condition),
        });
        return;
      }

      if (actionType === "HIDEOPTION") {
        const optionValue = getRuleActionOptionValue(action);
        if (!optionValue) return;

        fieldByName.set(targetAttributeId, {
          ...field,
          optionRules: [
            ...(Array.isArray(field.optionRules) ? field.optionRules : []),
            {
              type: "hide",
              optionValue,
              condition,
            },
          ],
        });
      }
    });
  });

  return (fields || []).map((field) => fieldByName.get(field.name) || field);
}

function doesConditionMatch(condition, formData) {
  if (!condition?.fieldName || !Array.isArray(condition?.values)) return false;

  const controllingValue = formData?.[condition.fieldName];
  const normalizedControllingValue = normalizeMetadataLabel(controllingValue);
  const matchesValue = condition.values.some(
    (value) =>
      String(value) === String(controllingValue) ||
      normalizeMetadataLabel(value) === normalizedControllingValue,
  );

  return condition.operator === "notEquals" ? !matchesValue : matchesValue;
}

export function isRegistrationFieldVisible(field, formData) {
  if (doesConditionMatch(field?.hiddenWhen, formData)) {
    return false;
  }

  const condition = field?.visibleWhen;
  if (!condition?.fieldName || !Array.isArray(condition?.values)) return true;

  return doesConditionMatch(condition, formData);
}

export function isRegistrationFieldRequired(field, formData) {
  if (!isRegistrationFieldVisible(field, formData)) {
    return false;
  }

  return Boolean(field?.required || doesConditionMatch(field?.requiredWhen, formData));
}

export function getRegistrationFieldOptions(field, formData) {
  const options = Array.isArray(field?.options) ? field.options : [];
  const optionRules = Array.isArray(field?.optionRules) ? field.optionRules : [];
  if (optionRules.length === 0) return options;

  return options.filter((option) => {
    const shouldHide = optionRules.some((rule) => {
      if (rule?.type !== "hide" || !doesConditionMatch(rule?.condition, formData)) {
        return false;
      }

      return [option?.value, option?.label].some(
        (candidate) =>
          String(candidate) === String(rule.optionValue) ||
          normalizeMetadataLabel(candidate) === normalizeMetadataLabel(rule.optionValue),
      );
    });

    return !shouldHide;
  });
}

function getAmsecLegacyField(attribute) {
  const labelKey = normalizeMetadataLabel(attribute?.displayName);

  return AMSEC_LEGACY_FIELDS.find((field) => field.match === labelKey) || null;
}

function getRegistrationFieldLabel(attribute, fallbackLabel) {
  const attributeId = String(attribute?.id || "").trim();
  const formName = stripMetadataLabelPrefix(attribute?.displayFormName || "");
  const amsecLegacyField = getAmsecLegacyField(attribute);
  const normalizedLabel = normalizeMetadataLabel(attribute?.displayName);

  if (formName) {
    return formName;
  }

  if (amsecLegacyField) {
    return amsecLegacyField.label;
  }

  if (LEGACY_LABEL_OVERRIDES_BY_NORMALIZED_LABEL[normalizedLabel]) {
    return LEGACY_LABEL_OVERRIDES_BY_NORMALIZED_LABEL[normalizedLabel];
  }

  if (attributeId && REGISTRATION_LABEL_OVERRIDES[attributeId]) {
    return REGISTRATION_LABEL_OVERRIDES[attributeId];
  }

  return stripMetadataLabelPrefix(fallbackLabel);
}

function stripMetadataLabelPrefix(label) {
  return String(label || "").replace(/^\s*(TEI|DPAT)\s*\|\s*/i, "").trim();
}

function isEventSectionHeaderLabel(label, programStage) {
  const normalizedLabel = normalizeMetadataLabel(label);
  const normalizedStageLabel = normalizeMetadataLabel(programStage?.displayName);

  return normalizedLabel === normalizedStageLabel || EVENT_SECTION_HEADER_LABELS.has(normalizedLabel);
}

function isYearAttribute(attribute) {
  const attributeId = String(attribute?.id || "").trim();
  const label = String(attribute?.displayName || "").trim();
  const valueType = String(attribute?.valueType || "").toUpperCase();

  if (YEAR_ATTRIBUTE_IDS.has(attributeId)) {
    return true;
  }

  if (!YEAR_FIELD_MATCHER.test(label)) {
    return false;
  }

  return NUMERIC_VALUE_TYPES.has(valueType) || valueType === "TEXT";
}

function isPhoneNumberAttribute(attribute) {
  const valueType = String(attribute?.valueType || "").toUpperCase();
  const attributeText = [
    attribute?.displayFormName,
    attribute?.displayName,
    attribute?.shortName,
    attribute?.description,
  ].join(" ");

  return valueType === "PHONE_NUMBER" || /\b(phone|telephone|mobile|contact\s+number)\b/i.test(attributeText);
}

function isGeneratedAttribute(attribute) {
  if (attribute?.generated) {
    return true;
  }

  const generatedHints = [
    attribute?.displayName,
    attribute?.shortName,
    attribute?.description,
    attribute?.pattern,
  ].join(" ");

  if (GENERATED_ATTRIBUTE_MATCHER.test(generatedHints)) {
    return true;
  }

  return Boolean(attribute?.unique && UNIQUE_ID_MATCHER.test(generatedHints));
}

function buildYearOptions() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 25;
  const endYear = currentYear + 5;
  const options = [];

  for (let year = endYear; year >= startYear; year -= 1) {
    const value = String(year);
    options.push({ label: value, value });
  }

  return options;
}

function getAttributeInputType(attribute, hasOptions) {
  const attributeId = String(attribute?.id || "").trim();
  const valueType = String(attribute?.valueType || "").toUpperCase();

  if (hasOptions) return "select";
  if (isYearAttribute(attribute)) return "select";
  if (valueType === "BOOLEAN" || valueType === "TRUE_ONLY") return "select";
  if (COORDINATE_VALUE_TYPES.has(valueType) || COORDINATE_ATTRIBUTE_IDS.has(attributeId)) return "coordinate";
  if (FILE_VALUE_TYPES.has(valueType) || FILE_ATTRIBUTE_IDS.has(attributeId)) return "file";
  if (TEXTAREA_VALUE_TYPES.has(valueType)) return "textarea";
  if (isPhoneNumberAttribute(attribute)) return "tel";
  if (NUMERIC_VALUE_TYPES.has(valueType)) return "number";
  return INPUT_TYPE_BY_VALUE_TYPE[valueType] || "text";
}

function getFieldDescription(entry, attribute, hasOptions) {
  const attributeId = String(attribute?.id || "").trim();
  const valueType = String(attribute?.valueType || "").toUpperCase();

  if (isGeneratedAttribute(attribute)) {
    return "This value is generated automatically when you register the record.";
  }

  if (COORDINATE_VALUE_TYPES.has(valueType) || COORDINATE_ATTRIBUTE_IDS.has(attributeId)) {
    return "Enter both latitude and longitude.";
  }

  if (valueType === "IMAGE" || FILE_ATTRIBUTE_IDS.has(attributeId)) {
    return "Upload an image file.";
  }

  if (valueType === "FILE_RESOURCE") {
    return "Upload a file attachment.";
  }

  return "";
}

function buildFieldPlaceholder(label, type, hasOptions, attribute) {
  if (isGeneratedAttribute(attribute)) {
    return "";
  }

  if (hasOptions || type === "select") {
    return `Select ${String(label || "an option").toLowerCase()}`;
  }

  if (type === "file") {
    return "";
  }

  if (type === "textarea") {
    return `Enter ${String(label || "details").toLowerCase()}`;
  }

  return `Enter ${String(label || "value").toLowerCase()}`;
}

export function getProgramRegistrationFields(programMetadata) {
  const trackedEntityAttributes = Array.isArray(programMetadata?.programTrackedEntityAttributes)
    ? programMetadata.programTrackedEntityAttributes
    : [];
  const trackedEntityTypeAttributes = Array.isArray(
    programMetadata?.trackedEntityType?.trackedEntityTypeAttributes,
  )
    ? programMetadata.trackedEntityType.trackedEntityTypeAttributes
    : [];
  const trackedEntityTypeAttributeById = new Map(
    trackedEntityTypeAttributes
      .filter((entry) => entry?.trackedEntityAttribute?.id)
      .map((entry) => [entry.trackedEntityAttribute.id, entry]),
  );
  const programAttributeIds = new Set(
    trackedEntityAttributes
      .map((entry) => entry?.trackedEntityAttribute?.id)
      .filter(Boolean),
  );
  const missingMandatoryTypeAttributes = trackedEntityTypeAttributes.filter(
    (entry) =>
      entry?.mandatory &&
      entry?.trackedEntityAttribute?.id &&
      !programAttributeIds.has(entry.trackedEntityAttribute.id),
  );

  return [...trackedEntityAttributes, ...missingMandatoryTypeAttributes]
    .slice()
    .map((entry, index) => {
      const attribute = entry?.trackedEntityAttribute || {};
      const attributeId = attribute?.id || `attribute-${index + 1}`;
      const typeAttribute = trackedEntityTypeAttributeById.get(attributeId);
      const amsecLegacyField = getAmsecLegacyField(attribute);
      const label = getRegistrationFieldLabel(
        attribute,
        stripMetadataLabelPrefix(attribute?.displayName || attribute?.shortName || attributeId),
      );
      const optionSetOptions = Array.isArray(attribute?.optionSet?.options)
        ? attribute.optionSet.options
        : [];
      const hasOptions = optionSetOptions.length > 0;
      const generated = isGeneratedAttribute(attribute);
      const isYearField = isYearAttribute(attribute);
      const fieldType = getAttributeInputType(attribute, hasOptions);
      const options = hasOptions
        ? optionSetOptions.map((option) => ({
            label: buildOptionLabel(option),
            value: buildOptionValue(option),
          }))
        : isYearField
          ? buildYearOptions()
        : fieldType === "select"
          ? [
              { label: "Yes", value: "true" },
              { label: "No", value: "false" },
            ]
          : [];

      return {
        name: attributeId,
        label,
        required: Boolean((entry?.mandatory || typeAttribute?.mandatory) && !generated),
        type: fieldType,
        options,
        span: fieldType === "textarea" || fieldType === "coordinate" || fieldType === "file" ? "full" : undefined,
        placeholder: buildFieldPlaceholder(label, fieldType, hasOptions, attribute),
        description: getFieldDescription(entry, attribute, hasOptions),
        generated,
        valueType: attribute?.valueType || "",
        legacyOrder:
          amsecLegacyField
            ? AMSEC_LEGACY_FIELDS.findIndex((field) => field.match === amsecLegacyField.match)
            : null,
        sortOrder: entry?.sortOrder ?? Number.MAX_SAFE_INTEGER,
      };
    })
    .filter(Boolean)
    .sort((left, right) => {
      const leftLegacyOrder = typeof left.legacyOrder === "number" ? left.legacyOrder : null;
      const rightLegacyOrder = typeof right.legacyOrder === "number" ? right.legacyOrder : null;

      if (leftLegacyOrder !== null && rightLegacyOrder !== null) {
        return leftLegacyOrder - rightLegacyOrder;
      }

      if (leftLegacyOrder !== null) return -1;
      if (rightLegacyOrder !== null) return 1;

      return left.sortOrder - right.sortOrder;
    })
    .map(({ legacyOrder, sortOrder, ...field }) => field);
}

function shouldIncludeGeometryField(programMetadata) {
  const programId = String(programMetadata?.id || "").trim();
  const featureType = String(
    programMetadata?.featureType || programMetadata?.trackedEntityType?.featureType || "",
  ).toUpperCase();
  const programLabel = normalizeMetadataLabel(
    [
      programMetadata?.displayName,
      programMetadata?.shortName,
      programMetadata?.description,
      programMetadata?.trackedEntityType?.displayName,
    ].join(" "),
  );

  return (
    featureType === "POINT" ||
    GEOMETRY_PROGRAM_IDS.has(programId) ||
    programLabel.includes("sanitation and waste tracker") ||
    programLabel.includes("sanitation waste tracker")
  );
}

export function buildRegistrationSectionsFromProgram(programMetadata) {
  const fields = applyProgramRuleConditions(
    addOtherSpecifyConditions(getProgramRegistrationFields(programMetadata)),
    programMetadata,
  );
  const hasGeometryField = fields.some(
    (field) => field?.isGeometry || field?.name === TRACKER_GEOMETRY_FIELD_NAME,
  );

  if (!hasGeometryField && shouldIncludeGeometryField(programMetadata)) {
    fields.push({
      name: TRACKER_GEOMETRY_FIELD_NAME,
      label: "Point on map",
      required: false,
      type: "coordinate",
      options: [],
      span: "full",
      placeholder: "",
      description: "Enter both latitude and longitude.",
      generated: false,
      valueType: "COORDINATE",
      isGeometry: true,
    });
  }

  if (fields.length === 0) return [];

  return [
    {
      title: programMetadata?.displayName
        ? `${programMetadata.displayName} Registration`
        : "Registration Details",
      description: "",
      fields,
    },
  ];
}

export function getProgramStageOptions(programMetadata) {
  const stages = Array.isArray(programMetadata?.programStages) ? programMetadata.programStages : [];

  return stages
    .filter((stage) => stage?.id)
    .map((stage) => ({
      label: stage?.displayName || stage?.name || stage.id,
      value: stage.id,
      stage,
    }));
}

export function getProgramStageEventFields(programStage) {
  const dataElements = Array.isArray(programStage?.programStageDataElements)
    ? programStage.programStageDataElements
    : [];

  return dataElements
    .slice()
    .map((entry, index) => {
      const dataElement = entry?.dataElement || {};
      const dataElementId = dataElement?.id || `data-element-${index + 1}`;
      const label = stripMetadataLabelPrefix(
        dataElement?.displayFormName ||
          dataElement?.formName ||
          dataElement?.displayName ||
          dataElement?.shortName ||
          dataElement?.name ||
          dataElementId,
      );
      const optionSetOptions = Array.isArray(dataElement?.optionSet?.options)
        ? dataElement.optionSet.options
        : [];
      const hasOptions = optionSetOptions.length > 0;
      const isYearField = isYearAttribute(dataElement);
      const fieldType = isYearField && !hasOptions
        ? "number"
        : getAttributeInputType(dataElement, hasOptions);
      const options = hasOptions
        ? optionSetOptions.map((option) => ({
            label: buildOptionLabel(option),
            value: buildOptionValue(option),
          }))
        : fieldType === "select"
          ? [
              { label: "Yes", value: "true" },
              { label: "No", value: "false" },
            ]
          : [];

      return {
        name: dataElementId,
        label,
        required: Boolean(entry?.compulsory),
        type: fieldType,
        options,
        span: fieldType === "textarea" || fieldType === "coordinate" || fieldType === "file" ? "full" : undefined,
        placeholder: buildFieldPlaceholder(label, fieldType, hasOptions, dataElement),
        description: dataElement?.description || "",
        generated: false,
        valueType: dataElement?.valueType || "",
        isSectionHeader: isEventSectionHeaderLabel(label, programStage),
        sortOrder: entry?.sortOrder ?? Number.MAX_SAFE_INTEGER,
      };
    })
    .filter(Boolean)
    .sort((left, right) => left.sortOrder - right.sortOrder)
    .map(({ sortOrder, ...field }) => field);
}
